// @ts-ignore
export function isString(data) {
    return typeof data === 'string';
}
// @ts-ignore
export function isNumber(data) {
    return typeof data === 'number' && !isNaN(data);
}
export function isDefined(data) {
    return typeof data !== 'undefined' && data !== null;
}
// @ts-ignore
export function isBoolean(data) {
    return typeof data === 'boolean';
}
// @ts-ignore
export function isPromise(data) {
    return data instanceof Promise;
}
// @ts-ignore
export function isArray(data) {
    return Array.isArray(data);
}
// @ts-ignore
export function isObject(data) {
    return !!data && !Array.isArray(data) && typeof data === 'object';
}
// @ts-ignore
export function isFunction(data) {
    return typeof data === 'function';
}
export function isNil(data) {
    return data == null;
}
// @ts-ignore
export function isError(data) {
    return data instanceof Error;
}
// @ts-ignore
export function isDate(data) {
    return data instanceof Date;
}
export function isTruthy(value) {
    return !!value;
}
export function isNot(predicate) {
    return function (data) {
        return !predicate(data);
    };
}
